import { GridRenderCellParams } from '@mui/x-data-grid-pro';

import { NPIDataGridColDef } from 'src/components/NPIDataGrid/NPIDataGrid';
import { createColumnDef } from 'src/components/NPIDataGrid/NPIDataGrid.utils';
import StatusChip from 'src/components/StatusChip';
import { enumToCamelCase } from 'src/lib/formatters';
import { formatDate } from 'src/utils/utils';

const gridColumns: NPIDataGridColDef[] = [
    { field: 'serviceNumber', headerName: 'Service ID' },
    { field: 'merchantAccountNumber', headerName: 'Merchant Account Number' },
    { field: 'merchantName', headerName: 'Merchant Name' },
    {
        field: 'dateActivated',
        headerName: 'Date Activated',
        renderCell: (params: GridRenderCellParams) => {
            return <>{params.value && formatDate({ date: params.value })}</>;
        },
    },
    { field: 'serviceType', headerName: 'Type' },
    {
        field: 'status',
        headerName: 'Status',
        renderCell: (params: GridRenderCellParams) => {
            return <StatusChip status={enumToCamelCase(params?.value ?? '')} />;
        },
    },
];

export default function ServicesTableColumnDef() {
    const columns = [...gridColumns];

    return columns.map((columnDef: NPIDataGridColDef) => {
        return createColumnDef(columnDef);
    });
}
